export default "__VITE_ASSET__73e6a1bf__"